import EfImg from '@elem/ui/ef-img';
import styled from './index.module.scss';
import { useLang } from '@/i18n';

const ActivityPreview = () => {
    const { t } = useLang('membersday.teaser.ActivityPreview');

    const list = [
        {
            value: '1',
            checked: false,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741764948302/ugc01.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1741766066219/ap_01_pad.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741765237591/ap_01_h5.jpg',
            title: '',
            text: t('itema'),
            textColor: t('itema1'),
        },
        {
            value: '2',
            checked: false,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741765652779/ap_02.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1741766259880/ap_02_pad.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741765655864/ap_02_h5.jpg',
            title: '',
            text: t('itemb2'),
            textColor: t('itemb1'),
        },
        {
            value: '3',
            checked: false,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741765683242/ap_03.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1741766263958/ap_03_pad.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741765686486/ap_03_h5.jpg',
            title: '',
            text: t('itemc'),
            textColor: t('itemc1'),
        },
    ];

    return (
        <div className={`${styled.ActivityPreview} teaser-ActivityPreview`} id="teaser-ActivityPreview">
            <div className="members-day-inter">
                <div className="members-day-title">
                    {t.rich('title', {
                        text: (text: string) => <span className="members-day-endtitle">{text}</span>,
                    })}
                </div>
                <div className="box-items">
                    {list.map((item) => (
                        <div key={item.value} className={`box-item`}>
                            <EfImg pc={item?.pc} pad={item?.pad} h5={item?.h5} />
                            <div className="box-msg">{item.text}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ActivityPreview;
